/** Line icons for menus and title-bar actions, on the same 24 px grid and stroke as the others. */
export type MenuIconName =
  | 'settings'
  | 'language'
  | 'signOut'
  | 'check'
  | 'plus'
  | 'trash'
  | 'pencil'
  | 'copy'
  | 'close'
  | 'run'
  | 'pause'
  | 'play'
  | 'chatPlus'
  | 'expand'
  | 'code'
  | 'team'
  | 'sparkles'
  | 'database'
  | 'file'
  | 'cloud'
  | 'refresh'
  | 'download'
  | 'record'
  | 'stop'
  | 'video'
  | 'summary'
  | 'bookmark'
  | 'branch'
  | 'share'
  | 'ask'
  | 'later'
  | 'mute';

const PATHS: Record<MenuIconName, string[]> = {
  summary: ['M9 6h11', 'M9 12h11', 'M9 18h7', 'M4.5 6h.01', 'M4.5 12h.01', 'M4.5 18h.01'],
  bookmark: ['M6 4h12v17l-6-4-6 4Z'],
  branch: [
    'M6 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
    'M6 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
    'M18 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
    'M6 7v10',
    'M18 7a12 12 0 0 1-12 12',
  ],
  share: ['M12 3v12', 'M7 8l5-5 5 5', 'M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6'],
  ask: ['M4 12a8 8 0 1 1 3.5 6.6L4 20l1.2-3.4A8 8 0 0 1 4 12Z'],
  later: ['M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z', 'M12 9v4l2.5 2', 'M9 2h6'],
  mute: ['M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15Z', 'M10 21a2 2 0 0 0 4 0', 'M4 4l16 16'],
  settings: [
    'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
    'M19.4 15a1.7 1.7 0 0 0 .34 1.88l.05.05a2 2 0 1 1-2.83 2.83l-.05-.05a1.7 1.7 0 0 0-1.88-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.07A1.7 1.7 0 0 0 9 19.37a1.7 1.7 0 0 0-1.88.34l-.05.05a2 2 0 1 1-2.83-2.83l.05-.05A1.7 1.7 0 0 0 4.6 15 1.7 1.7 0 0 0 3 14H3a2 2 0 1 1 0-4h.07A1.7 1.7 0 0 0 4.6 9 1.7 1.7 0 0 0 4.26 7.1l-.05-.05a2 2 0 1 1 2.83-2.83l.05.05A1.7 1.7 0 0 0 9 4.63 1.7 1.7 0 0 0 10 3.07V3a2 2 0 1 1 4 0v.07A1.7 1.7 0 0 0 15 4.63a1.7 1.7 0 0 0 1.88-.34l.05-.05a2 2 0 1 1 2.83 2.83l-.05.05A1.7 1.7 0 0 0 19.4 9 1.7 1.7 0 0 0 21 10h.07a2 2 0 1 1 0 4H21a1.7 1.7 0 0 0-1.6 1Z',
  ],
  language: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
    'M3 12h18',
    'M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18Z',
  ],
  signOut: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  check: ['M20 6 9 17l-5-5'],
  refresh: ['M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', 'M3 3v5h5'],
  plus: ['M12 5v14', 'M5 12h14'],
  trash: [
    'M4 7h16',
    'M10 11v6',
    'M14 11v6',
    'M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12',
    'M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3',
  ],
  pencil: ['M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4Z', 'm13.5 6.5 4 4'],
  copy: [
    'M8 10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2Z',
    'M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2',
  ],
  close: ['M18 6 6 18', 'm6 6 12 12'],
  download: ['M12 4v11', 'm7 10 5 5 5-5', 'M5 20h14'],
  record: [
    'M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z',
    'M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  ],
  stop: ['M7 7h10v10H7Z'],
  video: [
    'M5 6h9a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z',
    'm16 10 5-3v10l-5-3',
  ],
  run: ['M13 3v7h6l-8 11v-7H5l8-11Z'],
  pause: ['M7 5h3v14H7Z', 'M14 5h3v14h-3Z'],
  play: ['M7 4v16l13-8Z'],
  chatPlus: [
    'M8 9h8',
    'M8 13h6',
    'M12.5 20.5 8 18H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v5',
    'M16 19h6',
    'M19 16v6',
  ],
  expand: ['M16 4h4v4', 'm14 10 6-6', 'M8 20H4v-4', 'm4 20 6-6'],
  code: ['m7 8-4 4 4 4', 'm17 8 4 4-4 4', 'm14 4-4 16'],
  sparkles: [
    'M12 3 13.9 8.1 19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9Z',
    'M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8Z',
  ],
  database: [
    'M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3Z',
    'M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5',
    'M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  ],
  file: [
    'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z',
    'M14 3v5h5',
    'M9 13h6',
    'M9 17h4',
  ],
  cloud: ['M17.5 19a4.5 4.5 0 1 0-1.4-8.78A6 6 0 0 0 4.5 12.5 3.5 3.5 0 0 0 6.5 19Z'],
  team: [
    'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    'M3 20v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1',
    'M16 4.13a3 3 0 0 1 0 5.75',
    'M21 20v-1a4 4 0 0 0-3-3.85',
  ],
};

export function MenuIcon({ name }: { name: MenuIconName }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="nv-menu-icon"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
